function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import Input from '../Input';
import { getValidElementProps } from '../utils/htmlValidProps';

require('xps-style/core/search.css');

var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleActiveState", function (active) {
      _this.setState({
        active: active
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resetSearch", function () {
      _this.setState({
        query: '',
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeValue", function (e) {
      var handleChangeVal = _this.props.handleChangeVal;

      if (handleChangeVal !== undefined) {
        handleChangeVal(e);
      }

      _this.setState({
        query: e.target.value
      });
    });

    _this.state = {
      active: props.active,
      query: props.value
    };
    _this.toggleActiveState = _this.toggleActiveState.bind(_assertThisInitialized(_this));
    _this.resetSearch = _this.resetSearch.bind(_assertThisInitialized(_this));
    _this.handleChangeValue = _this.handleChangeValue.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;

      if (prevProps.value !== value) {
        this.setState({
          query: value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var divProps = getValidElementProps('div', this.props);
      var _this$state = this.state,
          active = _this$state.active,
          query = _this$state.query;
      var _this$props = this.props,
          size = _this$props.size,
          placeholder = _this$props.placeholder,
          label = _this$props.label,
          name = _this$props.name,
          autoComplete = _this$props.autoComplete,
          onClearListener = _this$props.onClearListener,
          onKeyDownListener = _this$props.onKeyDownListener,
          onKeyPressListener = _this$props.onKeyPressListener;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: "search__container"
      }, divProps), /*#__PURE__*/React.createElement(Input, {
        label: label,
        size: size,
        className: "search__input",
        placeholder: placeholder,
        value: query,
        name: name,
        icon: "search",
        search: true,
        onFocus: function onFocus() {
          _this2.toggleActiveState(true);
        },
        onClick: function onClick() {
          _this2.toggleActiveState(true);
        },
        onKeyDown: onKeyDownListener,
        onKeyPress: onKeyPressListener // onChange={this.props.onChangeListener}
        ,
        onChangeValue: this.handleChangeValue,
        autoComplete: autoComplete
      }), active && query !== '' ? /*#__PURE__*/React.createElement(Button, {
        className: label ? 'search__btn--close-label' : 'search__btn--close-no-label',
        kind: "borderless",
        iconName: "clear",
        icon: "only",
        size: size,
        onClick: function onClick(e) {
          onClearListener(e);

          _this2.resetSearch();
        }
      }) : null);
    }
  }]);

  return Search;
}(React.Component);

_defineProperty(Search, "propTypes", {
  // onChangeListener: PropTypes.func,
  onKeyDownListener: PropTypes.func,
  onKeyPressListener: PropTypes.func,
  onClearListener: PropTypes.func,
  handleChangeVal: PropTypes.func,

  /** Size of the search input: large, medium, or small */
  size: PropTypes.string,
  active: PropTypes.bool,

  /** Placeholder text for the search input */
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,

  /** Set to false if you don't want the autocomplete list to show up */
  autoComplete: PropTypes.bool,
  value: PropTypes.string
});

_defineProperty(Search, "defaultProps", {
  onKeyDownListener: function onKeyDownListener() {},
  onKeyPressListener: function onKeyPressListener() {},
  onClearListener: function onClearListener() {},
  size: 'large',
  active: false,
  autoComplete: true,
  value: ''
});

Search.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "toggleActiveState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "active",
      "type": null
    }],
    "returns": null
  }, {
    "name": "resetSearch",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleChangeValue",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Search",
  "props": {
    "onKeyDownListener": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyPressListener": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onClearListener": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "'large'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Size of the search input: large, medium, or small"
    },
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "autoComplete": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set to false if you don't want the autocomplete list to show up"
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "handleChangeVal": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder text for the search input"
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Search;